export enum AuthRoute {
  LOGIN = '/login',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
  JOIN = '/join',
  JOIN_SUCCESS = '/join/success',
  REGISTER = '/register',
  REGISTER_EMAIL = '/register/email',
  REGISTER_COMPANY = '/register/company',
  REGISTER_DOCUMENTS = '/register/documents',
  REGISTER_DOCUMENTS_SUCCESS = '/register/documents/success',
}
